import React, { Component } from 'react';
import styled from 'styled-components';
import { PrestoAppTheme } from 'presto-mini-apps-lib';
import { ContainerWidth, defaultOverlayStyle } from '../../constants/appState';
import {
    term_otp,
    term_password,
    term_select_login_method,
    term_transaction_pin
} from '../../constants/text';
import { MobileIcon, MobileSelectedIcon, PasswordIcon, PasswordSelectedIcon, PinIcon, PinSelectedIcon } from '../../assets/images';

class LoginMethodModal extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            isOpen,
            onClose,
            onSelected,
            selectMethod,
        } = this.props;

        return (
            <React.Fragment>
                <ModalOverlayWrapper className={[
                    'modal-overlay',
                    (!!isOpen ? ' show' : '')
                ].join('')}>
                    <div className="overlay" onClick={onClose} />
                    <ModalPanelWrapper className="popup-panel">
                        <div className="panel-body">
                            <div className="method-list">
                                <div className="header">Login with Mobile Number</div>
                                <ul>
                                    <li className={selectMethod === 'PIN' ? 'selector-list current' : 'selector-list'} onClick={() => onSelected('PIN')}>
                                        <div className="pin-icon" />
                                        <div className="label">{term_transaction_pin}</div>
                                        <div className="tick-icon" />
                                    </li>
                                    <li className={selectMethod === 'SMS' ? 'selector-list current' : 'selector-list'} onClick={() => onSelected('SMS')}>
                                        <div className="mobile-icon" />
                                        <div className="label">{term_otp}</div>
                                        <div className="tick-icon" />
                                    </li>
                                    <li className={selectMethod === 'PASS' ? 'selector-list current' : 'selector-list'} onClick={() => onSelected('PASS')}>
                                        <div className="password-icon" />
                                        <div className="label">{term_password}</div>
                                        <div className="tick-icon" />
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </ModalPanelWrapper>
                </ModalOverlayWrapper>
            </React.Fragment>
        );
    }
}

export default LoginMethodModal;


const commonBorderRadius = 6; // 6px
const commonBoxShadow = '0 1px 4px rgba(0, 0, 0, 0.1)';

const ModalOverlayWrapper = styled.div`
    display: none;
    position: fixed;
    width: calc(100% - ${PrestoAppTheme.layout.commonGap} * 2);
    max-width: ${ContainerWidth}px;
    bottom: 40px;
    height: 100%;
    justify-content: start;
    align-items: flex-end;
    overflow: hidden;
    z-index: 100;
    @media only screen and (max-width: 768px) {
        width: calc(100% - ${PrestoAppTheme.layout.commonGap} * 4);
    }
    @media only screen and (max-width: 320px) {
        width: calc(100% - ${PrestoAppTheme.layout.commonGap} * 3.3);
    }
    
    & .overlay {
        ${defaultOverlayStyle}
    }
    
    &.show {
        display: flex;
    }
`;

const ModalPanelWrapper = styled.div`
    position: absolute;
    width: 100%;
    border-radius: ${commonBorderRadius}px;
    box-shadow: ${commonBoxShadow};
    background-color: ${PrestoAppTheme.colors.white};
    display: flex;
    flex-direction: column;

    & .panel-body {
        padding: 0;
        text-align: left;
        box-sizing: border-box;
        flex: 3;
        font-weight: 300;
        font-size: 0.75rem;
        padding: ${PrestoAppTheme.layout.smallGap};
        
        & .title {
            text-align: center;
            font-weight: 500;
        }
        
        & .method-list {
            padding-top: ${PrestoAppTheme.layout.smallGap};

            & .header {
                text-align: left;
                padding: 0.5rem 0.5rem;
                font-weight: 500;
            }
            
            & ul {
                padding: 0;
                margin: 0;
                list-style: none;

                & li {
                    display: flex;
                    padding: ${PrestoAppTheme.layout.smallGap} ${PrestoAppTheme.layout.smallGap};
                    border-top: 1px solid #F5F5F5;
                    box-sizing: border-box;
                    justify-content: space-between;
                    align-items: center;
                    cursor: pointer;

                    &:first-child {
                        border: none;
                    }

                    & .mobile-icon {
                        position: relative;
                        height: 1.5em;
                        width: 1.5em;
                        background: url(${MobileIcon}) center / contain no-repeat;
                    }

                    & .password-icon {
                        position: relative;
                        height: 1.5em;
                        width: 1.5em;
                        background: url(${PasswordIcon}) center / contain no-repeat;
                    }

                    & .pin-icon {
                        position: relative;
                        height: 1.5em;
                        width: 1.5em;
                        background: url(${PinIcon}) center / contain no-repeat;
                    }

                    & .label {
                        flex-grow: 8;
                        text-align: left;
                        padding: 0 ${PrestoAppTheme.layout.smallGap};
                    }

                    & .tick-icon {
                        position: relative;
                        height: 1.5em;
                        width: 1.5em;
                        margin-left: 1rem;
                        border-radius: 50%;

                        &:before {
                            position: absolute;
                            top: 15%;
                            left: 32%;
                            display: none;
                            height: 0.7em;
                            width: 0.3em;
                            border: 2px solid #FFFFFF;
                            border-top: 0;
                            border-left: 0;
                            transform: rotate(45deg);
                            content: '';
                        }
                    }

                    &.current {

                        & .label {
                            color: #FA3532;
                        }

                        & .mobile-icon {
                            background: url(${MobileSelectedIcon}) center / contain no-repeat;
                        }

                        & .password-icon {
                            background: url(${PasswordSelectedIcon}) center / contain no-repeat;
                        }

                        & .pin-icon {
                            background: url(${PinSelectedIcon}) center / contain no-repeat;
                        }

                        & .tick-icon {
                            background-color: #FA3532;

                            &:before {
                                display: block;
                            }
                        }
                    }
                }
            }
        }
    }

`;

